<template>

  <div>
    <b-row>
      <div class="card-group mt-3">
      <b-col md="6" lg="3" class="my-1" v-for="(item, $index) in list" :key="$index">
        <div class="card propertycard">
          <div class="card-image">
            <a :href="'/nekretnine/' +  item.slug "><img class="card-img-top imgcont" :src="'https://square.ams3.digitaloceanspaces.com/property/'+item.image"></a>
          </div>
          <div :class="[item.purpose === 'prodaja' || item.purpose === 'izdavanje' ? 'mh-caption' : 'mh-caption-red']">
            <div class="mh-caption-inner">
              {{ item.purpose }}
            </div>
            </div>
        <div class="card-body">
          <h5 class="card-title cardtitle mb-0"><a :href="'/nekretnine/' +  item.slug ">
                                <span class="card-title tooltipped" data-position="bottom"
                                >{{ item.title }}</span></a>
          </a></h5>
          <i class="small material-icons left">place</i>
          <span class="font-italic text-capitalize">{{ item.address }}</span>
          <p class="mt-3 price">{{ item.price.toLocaleString('de-DE').replace(',', '.') }}€</p>
          <p class="font-weight-bold text-capitalize">Struktura: {{ item.type }}</p>
        </div>
        <div class="card-footer">
          <small class="text-muted">Objavljeno {{ item.createdAtHuman }}</small>
          <a :href="'/nekretnine/' +  item.slug " class="btn float-right text-uppercase btn-outline-primary">detaljnije</a>
        </div>
        </div>
      </b-col>
      </div>
    </b-row>
    <infinite-loading @distance="1" @infinite="infiniteHandler"></infinite-loading>
  </div>

</template>


<script>
export default {

  data() {
    return {
      list: [],
      page: 1,
    };
  },
  methods: {
    infiniteHandler($state) {
      axios.get('/api/propertiesjson', {
        params: {
          page: this.page,
        },
      }).then(({data}) => {
        if (data.data.length) {
          this.page += 1;
          this.list.push(...data.data);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ExampleComponent.vue